module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_8.5aee45ad.png";